import useSWR from "swr";
import Auth from "../Auth";

/**
 * Fetches the user's edit plugin installations.
 *
 * Each installation object has the shape:
 * {
 *   id: string,
 *   name: string,
 *   description: string | null,
 *   content: string,
 *   type: "SYSTEM" | "USER",
 *   key?: string,
 *   userId: string,
 *   published: boolean,
 *   installed: boolean,
 *   enabled: boolean,
 *   createdAt: Date,
 *   updatedAt: Date,
 *   canEdit: boolean,
 *   canDelete: boolean,
 *   // Category taxonomy fields (present on SYSTEM plugins):
 *   category: "developmental" | "line" | "dialogue" | "copy" | null,
 *   icon: string | null,
 *   defaultOrder: number | null,
 * }
 */
const useEditPluginInstallations = () => {
  const endpointURL = "/api/edit-plugins/installations";

  // The installations endpoint is a POST (it auto-creates defaults on first call)
  const fetcher = (url) =>
    Auth.fetchWithIdToken(url, { method: "POST" }).then((data) => data.installations);

  const { data: installations, error, isLoading, isValidating, mutate } = useSWR(endpointURL, fetcher, {
    revalidateOnFocus: false,
  });

  return {
    installations,
    refetch: mutate,
    error,
    isLoading,
    isValidating,
  };
};

export default useEditPluginInstallations;
